/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Switch, Space, Layout, Menu, Drawer, Button, Badge, message } from 'antd';
import { SunOutlined, MoonOutlined, UserOutlined, MenuOutlined, SettingOutlined } from '@ant-design/icons';
import { useSiteContext, useSiteContextUpdate } from '../context/SiteContext';
import constants from '../constants/Constants';
import { COOKIE, getCookie } from '../services/Cookie';
import { fronturls } from '../constants/FrontendURLs';
import { getUserType, logout } from '../pages/common/CommonFunctions';
import { useEffect } from 'react';
import { adminUIPaths, studentUIPaths } from '../pages/common/Pathnames';
import { apiurls } from '../constants/ApiURLs';
import { fetchApi } from '../services/Api';

const { Header } = Layout;

const Head = () => {
  const navigate = useNavigate();
  const { isDarkMode, username, currentPage } = useSiteContext()
  const { handleThemeChange, setCurrentPage } = useSiteContextUpdate()
  const [drawerVisible, setDrawerVisible] = useState(false);
  const userId = getCookie(COOKIE.UserId);
  const userType = getCookie(COOKIE.UserType);
  const isAdmin = userType === '1'
  const isAdminUrl = getUserType();
  const location = useLocation();

  useEffect(() => {
    getPageKey(location.pathname)
  }, [location.pathname]);

  //function to map the pages to keys of menu items
  const getPageKey = (pathname) => {
    const page = pathname.replace("/", ""); 

    let allPages = {};

    if (isAdmin) {
      allPages = adminUIPaths;
    } else {
      allPages = studentUIPaths;
    }

    for (const [key, values] of Object.entries(allPages)) {
      if (values.includes(page)) {
        setCurrentPage(key);
        break;
      }
    }
  }; 

  const renderMenuItems = () => {
    let userMenu = {
      label: username,
      icon: isAdmin ?
      <Badge count={<SettingOutlined className='!text-inherit' />}>
        <UserOutlined className='!text-xl' />
      </Badge> :
      <UserOutlined className='!text-xl' />,
      key: 'user',
      children: [
        {
          label: <Link to={fronturls.MyProfile}>{constants.MyProfile}</Link>,
          key: 'my-profile',
        },
        {
          label: constants.Logout,
          key: 'logout',
          onClick: () => logout(navigate)
        },
      ],
    }
    let menuItems = [
      {
        label: <Link to={fronturls.Home}>{constants.Home}</Link>,
        key: 'home',
      },
      {
        label: <Link to={fronturls.Help}>{constants.Help}</Link>,
        key: 'help',
      },
      {
        label: <Link to={fronturls.ContactUs}>{constants.ContactUs}</Link>,
        key: 'contact-us',
      },
      {
        label: <Link to={fronturls.Acknowledgements}>{constants.Acknowledgements}</Link>,
        key: 'acknowledgements',
      },
    ]
    let studentMenuItems = [
      {
        label: <Link to={fronturls.StudentDashboard}>{constants.Resources}</Link>,
        key: 'student-dashboard',
      },
      {
        label: <Link to={fronturls.MyScores}>{constants.MyScores}</Link>,
        key: 'my-scores',
      },
      {
        label: <Link to={fronturls.ContactUs}>{constants.ContactUs}</Link>,
        key: 'contact-us',
      },
      {
        label: <span onClick={()=>checkFeedback()}>{constants.Feedback}</span>,
        key: 'feedback',
      },
    ]
    let adminMenuItems = [
      {
        label: <Link to={fronturls.AdminDashboard}>{constants.Home}</Link>,
        key: 'admin-dashboard',
      },
      {
        label: constants.Users,
        key: 'users',
        children: [
          {
            label: <Link to={fronturls.AdminUsers}>{constants.AdminUsers}</Link>,
            key: 'admin-users',
          },
          {
            label: <Link to={fronturls.StudentUsers}>{constants.StudentUsers}</Link>,
            key: 'student-users',
          },
        ],
      },
      {
        label: constants.Resources,
        key: '/resources',
        children: [
          {
            label: <Link to={fronturls.Tests}>{constants.Tests}</Link>,
            key: 'tests',
          },
          {
            type: 'group',
            label: constants.Images,
            children: [
              {
                label: <Link to={fronturls.Images}>{constants.Images}</Link>,
                key: 'images',
              },
              {
                label: <Link to={fronturls.ImageQuizzes}>{constants.ImageQuizzes}</Link>,
                key: 'image-quizzes',
              },
            ],
          },
          {
            label: <Link to={fronturls.Videos}>{constants.Videos}</Link>,
            key: 'videos',
          },
          {
            label: <Link to={fronturls.Flashcards}>{constants.Flashcards}</Link>,
            key: 'flashcards',
          },
        ]
      },
      {
        label: "Analysis",
        key: "analysis",
        children: [
          {
            label: <Link to={fronturls.FlashcardAnalysis}>{constants.FlashcardAnalysis}</Link>,
            key: 'flashcard-analysis',
          },
          {
            label: <Link to={fronturls.ImageQuizScores}>{constants.ImageQuizScores}</Link>,
            key: 'image-quiz-scores',
          },
          {
            label: <Link to={fronturls.TestScore}>{constants.TestScore}</Link>,
            key: 'test-score',
          },
        ]
      },
      {
        label: "Masters",
        key: "masters",
        children: [
          {
            type: 'group',
            label: constants.Codes,
            children: [
              {
                label: <Link to={fronturls.CodeGeneration}>{constants.Generate}</Link>,
                key: 'generate-codes',
              },
              {
                label: <Link to={fronturls.CodesListing}>{constants.Listing}</Link>,
                key: 'book-code-list',
              },
            ],
          },
          {
            label: <Link to={fronturls.CronActivity}>{constants.Cron}</Link>,
            key: 'crons',
          },
          {
            label: <Link to={fronturls.DocumentsListing}>{constants.Documents}</Link>,
            key: 'documents',
          },
          {
            label: <Link to={fronturls.Settings}>{constants.Settings}</Link>,
            key: 'settings',
          },
          {
            label: <Link to={fronturls.UniversityListing}>{constants.Universities}</Link>,
            key: 'universities',
          },
        ]
      },
    ]
    studentMenuItems.push(userMenu)
    adminMenuItems.push(userMenu)
    
    if(!userId) {
      if(isAdminUrl) return []
      else return menuItems
    } else {
      if(isAdmin) return adminMenuItems
      else return studentMenuItems
    }
  }

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };

  const closeMobileMenu = () => {
		setDrawerVisible(false);
	};

  const checkFeedback = () => {
		fetchApi(`${apiurls.FeedbackGiven}${userId}`, "GET")
			.then((res) => {
				if (res?.code === 200) {
          const feedbackValue = res.data['is_feedback_given'];
          navigate(fronturls.Feedback, { state: { feedbackValue } });
				} else {
					message.error(res.message);
				}
			})
			.catch(() => {
				message.error(constants.SomethingWentWrong);
			});
	};

  const handleNavigate = () => {
    if (isAdmin) {
      navigate(fronturls.AdminDashboard);
    } else if (userType === "0") {
      navigate(fronturls.StudentDashboard);
    } else if (!userId) {
      navigate(fronturls.Home);
    }
  };

  return (
    <Header className="!px-2 lg:!px-10">
      <div className="flex items-center justify-between h-full">
        <Space
          wrap
          className="gap-y-0 cursor-pointer"
          onClick={() => handleNavigate()}
        >
          <svg
            stroke="#e7aa11"
            strokeWidth="2"
            className="text-line text-xl lg:text-4xl w-32 h-7 lg:w-60 lg:h-[45px]"
          >
            <text x="50%" dominantBaseline="middle" textAnchor="middle" y="50%">
              {constants.Logemanns}
            </text>
          </svg>
          <div className="text-[#e7aa11] text-xs sm:text-sm lg:text-lg 2xl:text-xl pl-1 lg:pl-0">
            {constants.EvalAndTrmnt}
          </div>
        </Space>
        <Space>
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[currentPage]}
            items={renderMenuItems()}
            disabledOverflow={true}
            className="text-sm 2xl:text-base hidden xl:block"
          />
          <Switch
            className="hidden"
            checked={isDarkMode}
            onChange={handleThemeChange}
            checkedChildren={
              <Space size={[3]}>
                <MoonOutlined className="text-sm" />
              </Space>
            }
            unCheckedChildren={
              <Space size={[3]}>
                <SunOutlined className="text-sm" />
              </Space>
            }
          />
        </Space>
        <Button
          className="xl:hidden"
          icon={<MenuOutlined className="text-neutral-50" />}
          onClick={toggleDrawer}
          type="text"
          size="large"
        />
        <Drawer
          title={<span>{constants.Logemanns}</span>}
          placement="right"
          onClose={closeMobileMenu}
          visible={drawerVisible}
          width={250}
          bodyStyle={{padding:'0'}}
        >
          <Menu
            mode="inline"
            items={renderMenuItems()}
            selectedKeys={currentPage}
          />
        </Drawer>
      </div>
    </Header>
  );
};

export default Head;
